import React from "react";
import PropTypes from "prop-types";

const AxisFiltersRecapItem = ({ filterName, filterValue, resultValue, unit }) => (
  <div className="flex w-24 flex-col text-xs print:text-xxs text-gray-500 font-lightt">
    <span className="underline underline-gray-500">{filterName}</span>
    <span className="w-max">
      <div>
        <span className="font-bold">{Number(parseFloat(filterValue).toFixed(2)) || "--"}</span>
        <span className=" "> {unit}</span>
      </div>
    </span>
    <div className="flex space-x-1 cursor-pointer italic">
      <div className="flex space-x-1 bg-gray-50">
        <span>{Number(parseFloat(resultValue).toFixed(2)) || "--"}</span>
        <span className="">{unit}</span>
      </div>
    </div>
  </div>
);

AxisFiltersRecapItem.propTypes = {
  filterName: PropTypes.string.isRequired,
  filterValue: PropTypes.string,
  resultValue: PropTypes.string,
  unit: PropTypes.string
};

AxisFiltersRecapItem.defaultProps = {
  filterValue: undefined,
  resultValue: undefined,
  unit: "unit"
};

export default AxisFiltersRecapItem;
